module.exports = __webpack_public_path__ + "img/top-category-culture.787d620a.jpg";